<div *ngIf="options">
  <input type="text"
         [disabled]="options.readOnly"
         placeholder="{{options.placeholder}}"
         id="{{options.elementId}}"
         (focus)="onInputFocus()"
         #ac
  >
</div>